import { render, staticRenderFns } from "./diagnosisResult.vue?vue&type=template&id=0d2bb1de&scoped=true"
import script from "./diagnosisResult.vue?vue&type=script&lang=js"
export * from "./diagnosisResult.vue?vue&type=script&lang=js"
import style0 from "./diagnosisResult.vue?vue&type=style&index=0&id=0d2bb1de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2bb1de",
  null
  
)

export default component.exports